import React from 'react';
import { Modal } from '../common/modal';
import { FormattedMessage } from 'react-intl';
import style from './loginRequiredModal.module.scss';
import { Row } from '../common/row';
import { LoginButton } from './loginButton';

export const LoginRequiredModal: React.SFC<{ closeUrl: string }>
    = ({ closeUrl }) => {
    return (
        <Modal
            modalHeaderContent={
                <FormattedMessage id={'components.auth.loginRequiredModal.header'} defaultMessage={'LOGIN REQUIRED'} />}
            isOpen={true}
            closeModal={history => history.push(closeUrl)}
        >
            <div>
                <Row className={style.Body}>
                    <FormattedMessage
                        id={'components.auth.loginRequiredModal.body'}
                        defaultMessage={'Please login or create an account to continue:'}
                    />
                </Row>
                <LoginButton className={style.Button}>
                    <FormattedMessage id={'components.auth.loginRequiredModal.link'} defaultMessage={'CREATE ACCOUNT'} />
                </LoginButton>
            </div>
        </Modal>
        );
    };
